import { CoordinatorCompanyService } from 'app/modules/coordinator/services/coordinator-company.service';
import { AsistentesPopupComponent } from './../../../../coordinator/components/coordinator-company/asistentes-popup/asistentes-popup.component';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { IDropDown } from '../../models/IDropDown';
import { RegistroService } from '../../../services/registro.service';
import moment from 'moment';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { CompanyRegistro } from '../../models/Registro/CompanyRegistro';
import { timeStamp } from 'console';
@Component({
    selector: 'app-visita-de-empresa-popup',
    templateUrl: './visita-de-empresa-popup.component.html',
    styleUrls: ['./visita-de-empresa-popup.component.scss'],
    standalone: false
})
export class VisitaDeEmpresaPopupComponent implements OnInit {

  public visitaEmpresaForm: UntypedFormGroup
  public tipoList: IDropDown<string>[]  
  public coordinatorList: IDropDown<string>[]
  public contactList:any;
  conactText:string="";
  
  public selectedContact:any [];

  constructor(
    public _dialogRef: MatDialogRef<VisitaDeEmpresaPopupComponent>,
    private dialog: MatDialog,
    public _fb: UntypedFormBuilder,
    private _sharedService: SharedService,
    private _registroService: RegistroService,    
    public _selectionService: SelectionGenericService,
    private coordinatorCompanyService: CoordinatorCompanyService,
    @Inject(MAT_DIALOG_DATA)
    private _dialogData: any
  ) {
    this.tipoList = [
      { viewValue: 'Visita del Médico', value: 'Visita del Médico' },
      { viewValue: 'Contacto Telefónico', value: 'Contacto Telefónico' },
      { viewValue: 'Llamada de la Empresa', value: 'Llamada de la Empresa' },
      { viewValue: 'Comentario Interno', value: 'Comentario Interno' },
    ];
    this.GetCoordinatorsList()
    //creates the form with default values
    this.CreateVisitaEmpresaForm(_dialogData.companyId);
    
    if (_dialogData.data !== null) {
      this.visitaEmpresaForm.patchValue({
        Id: _dialogData.data.id,
        Fecha: _dialogData.data.fecha,
        Tipo: _dialogData.data.titulo,
        Autor: _dialogData.data.autor,
        Asunto: _dialogData.data.asunto,
        Asistentes: _dialogData.data.asistentes,
        AsistentesEmpresa: _dialogData.data.asistentesEmpresa,
        AsistentesMutua: _dialogData.data.asistentesMutua,
        Comentarios: _dialogData.data.texto
      });
    }
    this.getPersonalContacto(_dialogData.companyId,_dialogData.data);

  }

  private CreateVisitaEmpresaForm(companyId: number): void { 
    this.visitaEmpresaForm = this._fb.group({
      Id: [0],
      EmpresaId: [companyId],
      Fecha: ['', Validators.required],
      Tipo: ['', Validators.required],
      Autor: ['', Validators.required],
      Asunto: [''],
      Asistentes: [''],
      Comentarios: [''],
      AsistentesEmpresa: [''],
      AsistentesMutua: [''],
    })
  }


  ngOnInit(): void {
    
  }

  private ConvertDateToStringSpanishFormat():UntypedFormGroup {      
    //This to avoid date reduce by 12 hours and when recieveing at the API  
    let getDate = this.visitaEmpresaForm.get('Fecha').value
    let formatedStringDate = moment(getDate).format('MM/DD/YYYY')
    //remove refference and create a new form object
    let formObject = {...this.visitaEmpresaForm.value} 
    formObject.Fecha = formatedStringDate
    return formObject
  }


  public onSubmit() {
    this.visitaEmpresaForm.markAllAsTouched();
    this.visitaEmpresaForm.updateValueAndValidity();
    if (this.visitaEmpresaForm.valid) {
      //This to avoid date reduce by 12 hours and when recieveing in API       
      let updatedForm = this.ConvertDateToStringSpanishFormat()
      //add data  
      if (this.visitaEmpresaForm.value.Id === 0) {
        this.AddVisitaEmpresa(updatedForm)
      } else {
        this.UpdateVisitaEmpresa(updatedForm)
      }
    }
  }

  cancel(submitSuccess: boolean) {
    this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
  }

  private AddVisitaEmpresa(obj) {
    this._registroService.AddVisitaEmpresa(obj)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Guardado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al crear', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }
  private getPersonalContacto(companyId,data)
  {
    this.contactList=[]
    this.selectedContact=[];
    this.coordinatorCompanyService.GetPersonalContacto(companyId).subscribe(res=>{
      if(res.result.length>0)
      {
        res.result.forEach(element => {
          let object =element;
          this.contactList.push(object)
        });

        if(data.asistentesEmpresa=== undefined)
        {
        }else{
         
          const arr = this.visitaEmpresaForm.get('AsistentesEmpresa')?.value.split(';');
          if(arr.length>0)
          {
            arr.forEach(element => {
              var nameArr = element.split('(');
              const result = this.contactList.filter((obj) => {
                return obj.nombre === nameArr[0].trim();
              });
              if(result.length > 0)
              {
                result.forEach(contact => {
                  this.selectedContact.push(contact.id)
                });
              }
            });
          }
        }
      }
    })
  }

  public openAddEditPopup(): void {
    const modalRef = this.dialog.open(AsistentesPopupComponent, {
   
    });
    modalRef.componentInstance.empresaId = this._dialogData.CompanyId;
    modalRef.componentInstance.contactList = this.contactList;
    modalRef.componentInstance.selectedContact = this.selectedContact;

    modalRef.afterClosed().subscribe(contactString => {
      this.conactText=contactString;
      if(contactString!=undefined)
      {
        this.visitaEmpresaForm.patchValue({
          AsistentesEmpresa:contactString
        })
      }
    });
  }

  private UpdateVisitaEmpresa(obj) {
    this._registroService.UpdateVisitaEmpresa(obj)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Actualizado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }

  public GetCoordinatorsList() {
    this._selectionService.GetCoordinatorList()
      .subscribe(res => {
        this.coordinatorList = res.result;
      })
  }

}
